import { wbLazy } from '@workbuzz/shared-ui';
import { AppRoute } from 'app/route/app';
import { ReportRoute } from 'app/route/report';

import { NavigationItem } from './models';

const SelectProjectPage = wbLazy(() =>
  import(
    /* webpackChunkName: "SelectProjectPage" */ 'view/SelectProjectPage/SelectProjectPage'
  ).then((module) => ({
    default: module['SelectProjectPage'],
  }))
);

const ProjectRoutes = wbLazy(() =>
  import(/* webpackChunkName: "ProjectRoutes" */ 'router/ProjectRoutes/ProjectRoutes').then(
    (module) => ({
      default: module['ProjectRoutes'],
    })
  )
);

const ReportRoutes = wbLazy(() =>
  import(/* webpackChunkName: "ReportRoutes" */ 'router/ReportRoutes/ReportRoutes').then(
    (module) => ({
      default: module['ReportRoutes'],
    })
  )
);

export const useAppRoutes = (): NavigationItem[] => {
  return [
    {
      path: ReportRoute.REPORT_PATTERN,
      component: ReportRoutes,
      canActivate: true,
    },
    {
      path: AppRoute.PROJECT_PATTERN,
      component: ProjectRoutes,
      canActivate: true,
    },
    {
      path: AppRoute.HOME,
      component: SelectProjectPage,
      canActivate: true,
    },
  ];
};
